import React from 'react'

interface OracleVoiceModeIconProps {
  className?: string
  color?: string
}

export const OracleVoiceModeIcon: React.FC<OracleVoiceModeIconProps> = ({ className = '', color = '#71428B' }) => {
  return (
    <div className={`oracle-voice-mode-icon ${className}`}>
      <svg width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="0.625" y1="-0.625" x2="15.375" y2="-0.625" transform="matrix(-2.9535e-06 -1 -1 6.46924e-10 8.5 20)" stroke={color} strokeWidth="1.25" strokeLinecap="round"/>
        <line x1="0.625" y1="-0.625" x2="4.70833" y2="-0.625" transform="matrix(9.71936e-08 -1 -1 -1.96586e-08 4.5 14.667)" stroke={color} strokeWidth="1.25" strokeLinecap="round"/>
        <line x1="0.625" y1="-0.625" x2="11.8194" y2="-0.625" transform="matrix(-1.1258e-05 -1 -1 4.98762e-10 12.5 18.2227)" stroke={color} strokeWidth="1.25" strokeLinecap="round"/>
        <line x1="0.625" y1="-0.625" x2="4.70833" y2="-0.625" transform="matrix(-2.62687e-05 -1 -1 0 16.5 14.667)" stroke={color} strokeWidth="1.25" strokeLinecap="round"/>
      </svg>
    </div>
  )
}

export default OracleVoiceModeIcon
